import React from "react";
import "./LoginPage.css";
import LoginVideoBox from "../../components/LoginVideoBox/LoginVideoBox";
import LoginForm from "../../components/LoginForm/LoginForm";
import { useEffect } from "react";

const LoginPage = () => {

  useEffect(() => {
    document.title = "Login | Brandly";
  }, []);

  return (
    <div className="login-page-wrapper">
      <main className="login-page-main-content">
        <div className="login-video-box-wrapper">
          <LoginVideoBox />
        </div>
        <LoginForm />
      </main>
    </div>
  );
};

export default LoginPage;
